





















import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class Indicador extends Vue {
    /* eslint-disable no-console */
    private chartData: any = [[]]; 
    private chartOptions: any = {};

               

    private created() {
        this.calificacionesTiendas()
    }

    private calificacionesTiendas() {
         this.$store.dispatch('GetPromediosByTienda')
        .then ((respuesta) => {

            this.chartData[0][0] = 'Tienda';
            this.chartData[0][1] = 'Porcentaje';

            for (let i of respuesta) {
                if (i.ID_NPS_ORIGEN === 4) {
                    this.chartData.push([i.TIENDA, (i.PROMOTORES - i.DETRACTORES) / (i.CONTEO) * 100])
                }
            }
           

            this.chartOptions = {
                title: 'NPS Ecommerce',
                height: 400,
                vAxes: {
                    0: {logScale: false},
                }, 
                series: {
                    0: {type: 'bars', targetAxisIndex:0 }
                }
            };
            
        })  
        .catch ((error) => {

        }); 
    }

 


}

